import { render } from "./IconBlockHelper.vue?vue&type=template&id=5471ce26"
import script from "./IconBlockHelper.vue?vue&type=script&lang=js"
export * from "./IconBlockHelper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconBlockHelper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5471ce26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5471ce26', __exports__)) {
    api.reload('5471ce26', __exports__)
  }
  
  module.hot.accept("./IconBlockHelper.vue?vue&type=template&id=5471ce26", () => {
    api.rerender('5471ce26', render)
  })

}


export default __exports__